<template>
    <v-dialog v-model="$store.state.parts.manageDeletePartDialog" width="500">
        <v-card>
            <v-card-title class="red white--text" primary-title>Are you sure you want to delete this part?</v-card-title>
            <v-card-text>
                <h5 class="title">This action cannot be undone</h5>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" text @click="closeDialog">Cancel</v-btn>
                <v-btn :loading="isLoading" :disabled="isLoading" color="error" @click="confirmDelete"><v-icon left>mdi-delete</v-icon>Delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {EventBus} from "../../../EventBus";
    import {PartsHttp} from "../../../http/parts";

    export default {
        name: "DeletePartDialog",
        data() {
            return {
                isLoading: false
            }
        },
        computed: {
            part: {
                get() {
                    return this.$store.state.parts.activePart;
                }
            }
        },
        methods: {
            closeDialog() {
                this.$store.dispatch('parts/setActivePart', {});
                this.$store.dispatch('parts/setParts');
                this.$store.dispatch('parts/setManageDeletePartDialog', false);
            },
            async confirmDelete() {
                this.isLoading = true;
                try {
                    await PartsHttp.deletePart(this.part._id);
                    EventBus.$emit('message', {message: 'Part deleted successfully', type: 'success'});
                    this.closeDialog();
                } catch (e) {
                    EventBus.$emit('message', {message: e, type: 'error'});
                } finally {
                    this.isLoading = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
